import React from 'react';
import Icon from '@mdi/react';

/**
 * Reusable circular social icon button.
 *
 * Usage:
 *   import SocialIcon from './SocialIcon';
 *   import { mdiLinkedin } from '@mdi/js';
 *   <SocialIcon path={mdiLinkedin} href="https://linkedin.com/in/..." title="LinkedIn" />
 */
const SocialIcon = ({ path, href, title, size = 1.2 }) => (
    <div
        onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
        title={title}
        role="link"
        aria-label={title}
        style={{
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            background: 'var(--void)',
            border: '1.5px solid rgba(26,26,46,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'border-color 0.2s, transform 0.2s',
        }}
        onMouseEnter={e => {
            e.currentTarget.style.borderColor = 'var(--spark)';
            e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'rgba(26,26,46,0.2)';
            e.currentTarget.style.transform = 'translateY(0)';
        }}
    >
        <Icon path={path} size={size} color="var(--ghost)" />
    </div>
);

export default SocialIcon;